const STORAGE_KEY_SEARCH_HISTORY = "recsch";

export function saveSearchHistory(cartItemLength) {
  window.localStorage.setItem(STORAGE_KEY_SEARCH_HISTORY, cartItemLength);
}

export function loadSearchHistory() {
  return window.localStorage.getItem(STORAGE_KEY_SEARCH_HISTORY);
}

export function removeSearchHistory() {
  window.localStorage.removeItem(STORAGE_KEY_SEARCH_HISTORY);
}
